import React from 'react';
import styled from 'styled-components';

import { RegistroImpuestosEstado } from '../../models';

import { Card, Steps } from 'antd';

interface StepStatusProps {
    estado: RegistroImpuestosEstado;
}

const StepStatusWrapper = styled(Card)`
    margin-bottom: 24px !important;
    .ant-card-body {
        padding: 24px 40px !important;
    }
`;

class StepStatus extends React.Component<StepStatusProps> {
    obtenerSteps = (estadoComprobar: RegistroImpuestosEstado) => {
        const Step = Steps.Step;
        if (estadoComprobar === RegistroImpuestosEstado.Rechazado) {
            const { estado } = this.props;
            return estado === RegistroImpuestosEstado.Rechazado ? (
                <Step title={estadoComprobar} key={estadoComprobar} style={{ textAlign: 'left' }} />
            ) : estado === RegistroImpuestosEstado.Corregido ? (
                <Step title={estadoComprobar} key={estadoComprobar} style={{ textAlign: 'left' }} />
            ) : null;
        } else if (estadoComprobar === RegistroImpuestosEstado.Corregido) {
            const { estado } = this.props;
            return estado === RegistroImpuestosEstado.Corregido ? (
                <Step title={estadoComprobar} key={estadoComprobar} style={{ textAlign: 'left' }} />
            ) : estado === RegistroImpuestosEstado.Rechazado ? (
                <Step title={estadoComprobar} key={estadoComprobar} style={{ textAlign: 'left' }} />
            ) : null;
        } else {
            return (
                <Step title={estadoComprobar} key={estadoComprobar} style={{ textAlign: 'left' }} />
            );
        }
    };

    render() {
        const { estado } = this.props;
        const indice = Object.keys(RegistroImpuestosEstado).indexOf(estado.replace(' ', ''));
        return (
            <StepStatusWrapper bordered={false}>
                <Steps
                    current={indice}
                    status={estado === RegistroImpuestosEstado.Rechazado ? 'error' : 'process'}
                >
                    {Object.values(RegistroImpuestosEstado).map(value => this.obtenerSteps(value))}
                </Steps>
            </StepStatusWrapper>
        );
    }
}
export default StepStatus;
